export const MENU_TOGGLE = "MENU_TOGGLE";
export const SIDER_TOGGLE = "SIDER_TOGGLE";

export const GET_CONFIG_PENDING = "GET_CONFIG_PENDING";
export const GET_CONFIG_SUCCES = "GET_CONFIG_SUCCES";
export const GET_CONFIG_FAILURE = "GET_CONFIG_FAILURE";
